<template>
  <q-page class="main">
    <q-card  class="page-card">
      <q-card-section v-if="$isDesktop" class="page-card__main-content">
        <h1 class="heading-2 q-mb-lg">Thema's</h1>
        <div class="row items-center justify-between">
          <div class="col-shrink">
            Kies een thema uit de lijst.
          </div>
        </div>
      </q-card-section>

      <q-card-section v-else class="page-card__main-content">
        <h1 class="heading-2 q-pl-sm">Thema's</h1>
        <theme-index :themes="themas" class="q-mt-md"/>
      </q-card-section>
    </q-card>
    <sticky-top-bar>
      <accent-button v-if="$isDesktop" label="Nieuw thema" @click="$goto('theme.create')" />
    </sticky-top-bar>
    <sticky-bottom-bar v-if="!$isDesktop">
      <common-fab label="Nieuw thema" @click="$goto('theme.create')" />
    </sticky-bottom-bar>
  </q-page>
</template>

<script>
import ThemeIndex from '~HIOR/components/sidebars/ThemeIndex'

export default {
  components: {
    ThemeIndex
  },
  props: {
    themas: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
